import { trackingIncomingMessage } from './tracking';
import { EChatActionTypes } from '../../actions/chat';
import { ESendMessageActionTypes, ISendMessagePayload } from '../../actions/sendMessage';
import { ERequestApiStatus, TAppState } from '../../types/appState';
import { TOutcomingStatus } from '../../types/messages';
import { TReduxActions } from '../../types/redux/actions';
import { addNewChat } from '../../utils/addNewChat';
import { insertMessageInPage, removeMessageFromPage } from '../../utils/messageUtils';

function updateState(state: TAppState, { message, messageId }: ISendMessagePayload, status?: TOutcomingStatus) {
  const chatId = message.chatId;
  const pages = removeMessageFromPage(messageId, state.chatWindow.messagesMap, state.openedChats[chatId].pages);

  return {
    ...state,
    openedChats: {
      ...state.openedChats,
      [chatId]: {
        ...state.openedChats[chatId],
        pages: insertMessageInPage(state.chatWindow.messagesMap, message, pages, state.user.userId, status),
      },
    },
  };
}

export function openedChatsReducer(state: TAppState, action: TReduxActions): TAppState {
  const userId = state.user.userId;

  switch (action.type) {
    case ESendMessageActionTypes.SetPending:
      return updateState(state, action.payload, 'pending');

    case ESendMessageActionTypes.SetFailed:
      return updateState(state, action.payload, 'failed');

    case ESendMessageActionTypes.SetSuccess:
      return updateState(state, action.payload);

    case ESendMessageActionTypes.SetFirstMessageSuccess:
      const fistMessageChatId = action.payload.message.chatId;

      // Создаем чат при успешном ответе
      const openedChats = addNewChat({
        openedChats: state.openedChats,
        chats: state.chatList.chats,
        currentChatId: fistMessageChatId,
      });

      // Вставляем первое сообщение после ответа по вебсокету
      const newPages = insertMessageInPage(state.chatWindow.messagesMap, action.payload.message, [], userId);

      return {
        ...state,
        chatWindow: {
          ...state.chatWindow,
          currentOpenedChatId: fistMessageChatId,
        },
        openedChats: {
          ...openedChats,
          [fistMessageChatId]: {
            ...openedChats[fistMessageChatId],
            pages: newPages,
            status: ERequestApiStatus.Succeed,
          },
        },
      };
    case ESendMessageActionTypes.SetAbort:
      const { message, messageId } = action.payload;
      const chatId = message.chatId;

      const pages = removeMessageFromPage(messageId, state.chatWindow.messagesMap, state.openedChats[chatId].pages);

      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [chatId]: {
            ...state.openedChats[chatId],
            pages,
          },
        },
      };

    case EChatActionTypes.IncomingMessage:
      const openedChat = state.openedChats[action.payload.chatId];

      if (!openedChat) {
        return state;
      }

      if (action.payload.userId !== userId) {
        trackingIncomingMessage(action.payload.chatId);
      }

      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...openedChat,
            pages: insertMessageInPage(state.chatWindow.messagesMap, action.payload, openedChat.pages, userId),
          },
        },
      };

    case EChatActionTypes.SetEditableMessage:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...state.openedChats[action.payload.chatId],
            editableMessage: action.payload.text,
          },
        },
      };

    case EChatActionTypes.DisableSendDefaultMessage:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...state.openedChats[action.payload.chatId],
            sendDefaultMessage: false,
          },
        },
      };

    case EChatActionTypes.Close:
      return {
        ...state,
        chatWindow: {
          ...state.chatWindow,
          currentOpenedChatId: '',
        },
      };

    case EChatActionTypes.SetBubbleInputFocus:
      return {
        ...state,
        chatWindow: {
          ...state.chatWindow,
          isBubbleInputFocused: action.payload.isBubbleInputFocused,
        },
      };

    case EChatActionTypes.Reset:
      return {
        ...state,
        chatWindow: {
          isChatOperationPending: false,
          isBubbleInputFocused: false,
          currentOpenedChatId: null,
          messagesMap: new Map(),
          serealizebleMap: undefined,
        },
        openedChats: {},
      };

    default:
      return state;
  }
}
